import { Box, Skeleton, SxProps, Theme } from "@mui/material";
import BaseCard from "./BaseCard";

interface GenericCardSkeletonProps {
  hasStatusLine?: boolean;
  hasMediaRow?: boolean;
  mediaCount?: number;
  sx?: SxProps<Theme>;
  mb?: string | number;
}

const GenericCardSkeleton = ({ 
  hasStatusLine = false, 
  hasMediaRow = false, 
  mediaCount = 3,
  sx,
  mb = "3.8%"
}: GenericCardSkeletonProps) => {
  return (
    <BaseCard
      sx={{
        p: 2,
        mb,
        ...sx,
      }}
    >
      {hasStatusLine && (
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton width="40%" height={14} />
        </Box>
      )}

      <Box display="flex" gap={2}>
        <Skeleton variant="rounded" width={48} height={48} />
        <Box flex={1}>
          <Skeleton width="60%" height={18} />
          <Skeleton width="80%" height={14} />
        </Box>
      </Box>

      {hasMediaRow && (
        <>
          <Box mt={2}>
            <Skeleton width="30%" height={16} />
            <Skeleton variant="rounded" height={60} sx={{ mt: 1 }} />
          </Box>

          <Box mt={2} display="flex" gap={1}>
            {Array.from({ length: mediaCount }).map((_, i) => (
              <Skeleton key={i} variant="rounded" width={50} height={50} />
            ))}
          </Box>
        </>
      )}
    </BaseCard>
  );
};

export default GenericCardSkeleton;
